<!-- 预提醒明细表 -->
<!--eslint-disable vue/no-unused-refs-->
<template>
  <div>
    <!-- 搜索区 -->
     <!--  eslint-disable-next-line vue/no-unused-refs -->
    <el-form class="mt16" :model="searchData" :rules="rules" ref="search">
      <!--  eslint-disable-next-line vue/no-unused-refs -->
      <QS-search maxLine="2" ref="BLM-search">
        <el-form-item prop="receivableId" label="应收ID">
          <el-input
            v-number:integer
            v-model="searchData.receivableId"
            placeholder="请输入应收ID"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item prop="plateNo" label="车牌号">
          <el-select
              v-model="searchData.carId"
              filterable
              remote
              reserve-keyword
              clearable
              placeholder="请输入"
              :remote-method="
                (query) => {
                  loadPlateNoData(query)
                }
              "
              :loading="oLoading.fuzzy"
              @visible-change="
                (e) => {
                  changeValue(e)
                }
              "
            >
              <el-option
                v-for="item in plateNoData"
                :key="'options' + item.id"
                :label="item.plateNo"
                :value="item.id"
              >
              </el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="客户来源" prop="customerType">
          <el-select
            v-model="searchData.customerType"
            clearable
            placeholder="请选择客户来源"
          >
            <el-option
              v-for="item in customerTypeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="customerName" label="客户名称">
          <el-select
              v-model="searchData.customerId"
              filterable
              clearable
              remote
              placeholder="请输入"
              :remote-method="
                (query) => {
                  loadNameData(query)
                }
              "
              :loading="oLoading.fuzzySearch"
              @visible-change="
                (e) => {
                  changeValue(e, 'customerManage')
                }
              "
            >
              <el-option
                v-for="item in curstomerNameData"
                :key="item.id"
                :label="item.customerName"
                :value="item.id"
              >
                <CustomerNameOptionItem :data="item" />
              </el-option>
            </el-select>
        </el-form-item>
        <el-form-item prop="dateRange" label="日期选择">
          <el-date-picker
            v-model="dateRange"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd HH:mm:ss"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            clearable
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="预提醒阶段" prop="remindLevel">
          <el-select
            v-model="searchData.remindLevel"
            clearable
            placeholder="请选择预提醒阶段"
          >
            <el-option
              v-for="item in remindLevelOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="还款状态">
          <el-select
            clearable
            placeholder="请选择还款状态"
            v-model="searchData.finishState"

          >
            <el-option
              v-for="item in receivableStateOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <CarBrandSeriesModel
          ref="carBrandSeriesModelRef"
          v-model="brandSeriesModel"
          :showModel="true"
          :filterScene="CAR_MODEL_FILTER_SCENE.IN_STOCK"
        ></CarBrandSeriesModel>

        <el-form-item label="租赁状态">
          <!-- 多选状态下使用 collapse-tags 否则会有界面bug -->
          <el-select
            clearable
            placeholder="请选择租赁状态"
            v-model="searchData.orderStateList"
            multiple
            collapse-tags
          >
            <el-option
              v-for="item in leaseStatusOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>


        <template slot="moreBtn">
          <el-form-item>
            <el-button
              :loading="oLoading.search"
              type="primary"
              @click="searchHandle"
              >查询</el-button
            >
          </el-form-item>
          <el-form-item>
            <el-button @click="reset('search')">重置</el-button>
          </el-form-item>
          <el-form-item>
            <export
              :exportTemplate="exportTemplate"
              filename="预提醒明细.xlsx"
              :params="exportParams"
              v-if="judgePermission('under_lease_over_due_hasten_debt_remind_list_export')"
            ></export>
          </el-form-item>
        </template>
      </QS-search>
    </el-form>

    <!-- 列表 -->
    <QS-common-table
      :loading="oLoading.search"
      :data="tableData"
      :columns="columns"
      :pagination="paginationData"
      @change="paginationChange"
    >
    </QS-common-table>

  </div>
</template>
<script>
import config from '../config/detailList/remindDetailList'
import { getRemindItems } from '@/api/domain/orders'
import CustomerNameOptionItem from '@/components/CustomerSelect/optionItem'
import Mixin from '../mixins'
import { CAR_MODEL_FILTER_SCENE } from '@/config/carManage'

const mixin = Mixin({
  getListFn: getRemindItems,
  searchData: {
    receivableId: '', // 应收ID
    carId: '', // 车牌号
    startDate: '', // 欠款开始时间
    endDate: '', // 欠款结束时间
    customerType: '', // 客户来源
    customerName: '', // 客户名称
    customerId: '', // 客户ID
    remindLevel: '', // 预提醒阶段
    finishState: '', // 还款状态
    orderStateList: [], // 租赁状态
  },
  exportTemplate: 'Remind',
})

export default {
  mixins: [mixin],
  components: {
    CustomerNameOptionItem,
  },
  data() {
    const {
      columns,
      rules,
      customerTypeOptions,
      remindLevelOptions,
      receivableStateOptions,
      leaseStatusOptions,
    } = config.call(this)
    return {
      columns,
      rules,
      customerTypeOptions,
      remindLevelOptions,
      receivableStateOptions,
      leaseStatusOptions,
      brandSeriesModel: {},
      CAR_MODEL_FILTER_SCENE,
    }
  },
  methods: {
    // 催租收款
    // eslint-disable-next-line vue/no-unused-properties
    toPayment(row) {
      this.$router.push({
        path: '/underLease/overdue/detailList/addCollection',
        query: {
          paymentIds: row.receivableId,
          type: 'remind',
          remindId: row.id,
          approvalOrigin: 7,
        },
      })
    },
  },
}
</script>
<style scoped lang="scss">
.customer{
  display: flex;
  flex-direction: row;
  &-name{
    width: 100px;
    height: 35px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  &-phone{
    color: #8492a6;
    font-size: 13px;
    padding-left: 20px;
  }
}
</style>

